var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"contact-button"},[_c('a',{staticClass:"link-to",attrs:{"href":_vm.$link.contactPage()}},[_c('img',{attrs:{"src":"/images/btn_contact.png","alt":"contact"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }